const Lang = {
    en: {
      page_not_found: "Page Not Found!",
      page_not_exist: "This Page Does not exist!",
      Go_Back: "Go Back",
      search: "Search",
      gptSearchPlaceholder: "What would you like to watch today?",
      SignIn: "Sign In",
      SignUp: "Sign Up",
      NamePlaceholder: "Name",
      EmailPlaceholder: "Email",
      PasswordPlaceholder: "Password",
      Or: "Or",
      SignInwithGoogle: "Sign In with Google",
      Already_have_an_Account: "Already have an Account?",
      New_to_Netflix: "New to Netflix?",
      Sign_in_now: "Sign in now.",
      Sign_up_now: "Sign up now.",
      Now_Playing_Movies: "Now Playing Movies",
      Popular_Movies: "Popular Movies",
      Top_Rated_Movies: "Top Rated Movies",
      Trending_Movies: "Trending Movies",
      Upcoming_Movies: "Upcoming Movies",
      Log_Out: "Log Out",
      Play_Now: "Play",
      More_Info: "More Info",
      Frequently_Asked_Questions: "Frequently Asked Questions",
    },
    hindi: {
      page_not_found: "पृष्ठ नहीं मिला!",
      page_not_exist: "यह पृष्ठ मौजूद नहीं है!",
      Go_Back: "वापस जाओ",
      search: "खोज",
      gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
      SignIn: "साइन इन करें",
      SignUp: "साइन अप करें",
      NamePlaceholder: "नाम",
      EmailPlaceholder: "ईमेल",
      PasswordPlaceholder: "पासवर्ड",
      Or: "या",
      SignInwithGoogle: "गूगल के साथ साइन इन करें",
      Already_have_an_Account: "क्या आपके पास पहले से एक खाता है?",
      New_to_Netflix: "नेटफ्लिक्स पर नए हैं?",
      Sign_in_now: "अभी साइन इन करें।",
      Sign_up_now: "अभी साइन अप करें।",
      Now_Playing_Movies: "अब चल रही फिल्में",
      Popular_Movies: "लोकप्रिय फिल्में",
      Top_Rated_Movies: "सर्वश्रेष्ठ रेटेड फिल्में",
      Upcoming_Movies: "आगामी फिल्में",
      Trending_Movies: "ट्रेंडिंग फिल्में",
      Log_Out: "लॉग आउट करें",
      Play_Now: "अभी चलाएं",
      More_Info: "अधिक जानकारी",
      Frequently_Asked_Questions: "अक्सर पूछे जाने वाले प्रश्न",
    },
    spanish: {
      page_not_found: "¡Página no encontrada!",
      page_not_exist: "¡Esta página no existe!",
      Go_Back: "Regresar",
      search: "Buscar",
      gptSearchPlaceholder: "¿Qué te gustaría ver hoy?",
      SignIn: "Iniciar Sesión",
      SignUp: "Regístrate",
      NamePlaceholder: "Nombre",
      EmailPlaceholder: "Correo Electrónico",
      PasswordPlaceholder: "Contraseña",
      Or: "O",
      SignInwithGoogle: "Iniciar sesión con Google",
      Already_have_an_Account: "¿Ya tienes una cuenta?",
      New_to_Netflix: "¿Eres nuevo en Netflix?",
      Sign_in_now: "Inicia sesión ahora.",
      Sign_up_now: "Regístrate ahora.",
      Now_Playing_Movies: "Películas en Cartelera",
      Popular_Movies: "Películas Populares",
      Top_Rated_Movies: "Películas Mejor Calificadas",
      Upcoming_Movies: "Próximas Películas",
      Trending_Movies: "Películas de moda",
      Log_Out: "Cerrar Sesión",
      Play_Now: "Reproducir Ahora",
      More_Info: "Más Información",
      Frequently_Asked_Questions: "Preguntas Frecuentes",
    },
    telugu: {
      page_not_found: "పేజీ దొరకలేదు!",
      page_not_exist: "ఈ పేజీ లేనే లేదు!",
      Go_Back: "తిరిగి వెళ్ళండి",
      search: "శోధించండి",
      gptSearchPlaceholder: "ఈ రోజు మీరు ఏమి చూడాలనుకుంటున్నారు?",
      SignIn: "సైన్ ఇన్ చేయండి",
      SignUp: "సైన్ అప్ చేయండి",
      NamePlaceholder: "పేరు",
      EmailPlaceholder: "ఇమెయిల్",
      PasswordPlaceholder: "పాస్వర్డ్",
      Or: "లేదా",
      SignInwithGoogle: "గూగుల్‌తో సైన్ ఇన్ చేయండి",
      Already_have_an_Account: "మీకు ఇప్పటికే ఖాతా ఉందా?",
      New_to_Netflix: "నెట్‌ఫ్లిక్స్‌కు కొత్తవారా?",
      Sign_in_now: "ఇప్పుడు సైన్ ఇన్ చేయండి.",
      Sign_up_now: "ఇప్పుడు సైన్ అప్ చేయండి.",
      Now_Playing_Movies: "ఇప్పుడు ప్రదర్శిస్తున్న సినిమాలు",
      Popular_Movies: "ప్రసిద్ధ సినిమాలు",
      Top_Rated_Movies: "అత్యుత్తమ రేటింగ్ సినిమాలు",
      Upcoming_Movies: "రాబోయే సినిమాలు",
      Trending_Movies: "ట్రెండింగ్ సినిమాలు",
      Log_Out: "లాగ్ అవుట్ చేయండి",
      Play_Now: "ఇప్పుడు ప్లే చేయండి",
      More_Info: "మరిన్ని వివరాలు",
      Frequently_Asked_Questions: "తరచుగా అడిగే ప్రశ్నలు",
    },
    tamil: {
        page_not_found: "பக்கம் கிடைக்கவில்லை!",
        page_not_exist: "இந்த பக்கம் இல்லை!",
        Go_Back: "திரும்பிச் செல்லவும்",
        search: "தேடுங்கள்",
        gptSearchPlaceholder: "இன்று நீங்கள் என்ன பார்க்க விரும்புகிறீர்கள்?",
        SignIn: "உள்நுழைக",
        SignUp: "பதிவு செய்யவும்",
        NamePlaceholder: "பெயர்",
        EmailPlaceholder: "மின்னஞ்சல்",
        PasswordPlaceholder: "கடவுச்சொல்",
        Or: "அல்லது",
        SignInwithGoogle: "Google உடன் உள்நுழைக",
        Already_have_an_Account: "ஏற்கனவே கணக்கு உள்ளதா?",
        New_to_Netflix: "Netflix இல் புதியவரா?",
        Sign_in_now: "இப்போது உள்நுழைக.",
        Sign_up_now: "இப்போது பதிவு செய்யவும்.",
        Now_Playing_Movies: "இப்போது நடக்கும் படங்கள்",
        Popular_Movies: "பிரபலமான படங்கள்",
        Top_Rated_Movies: "சிறந்த மதிப்பீட்டப்பட்ட படங்கள்",
        Upcoming_Movies: "வரவிருக்கும் படங்கள்",
        Trending_Movies: "பிரபலமான திரைப்படங்கள்",
        Log_Out: "வெளியேறு",
        Play_Now: "இப்போது பிளே செய்யவும்",
        More_Info: "மேலும் தகவல்",
        Frequently_Asked_Questions: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      },
    
    marathi: {
      page_not_found: "पृष्ठ सापडले नाही!",
      page_not_exist: "हे पृष्ठ अस्तित्वात नाही!",
      Go_Back: "मागे जा",
      search: "शोधा",
      gptSearchPlaceholder: "आज तुम्हाला काय पहायचे आहे?",
      SignIn: "साइन इन करा",
      SignUp: "नोंदणी करा",
      NamePlaceholder: "नाव",
      EmailPlaceholder: "ईमेल",
      PasswordPlaceholder: "पासवर्ड",
      Or: "किंवा",
      SignInwithGoogle: "Google सह साइन इन करा",
      Already_have_an_Account: "तुमच्याकडे आधीपासून खाता आहे का?",
      New_to_Netflix: "Netflix वर नवीन आहात?",
      Sign_in_now: "आता साइन इन करा.",
      Sign_up_now: "आता नोंदणी करा.",
      Now_Playing_Movies: "आता चालू चित्रपट",
      Popular_Movies: "लोकप्रिय चित्रपट",
      Top_Rated_Movies: "उच्च रेट केलेले चित्रपट",
      Upcoming_Movies: "आगामी चित्रपट",
      Trending_Movies: "ट्रेंडिंग चित्रपट",
      Log_Out: "लॉग आऊट करा",
      Play_Now: "आत्ता प्ले करा",
      More_Info: "अधिक माहिती",
      Frequently_Asked_Questions: "वारंवार विचारले जाणारे प्रश्न",
    },
    french: {
      page_not_found: "Page non trouvée!",
      page_not_exist: "Cette page n'existe pas!",
      Go_Back: "Retourner",
      search: "Rechercher",
      gptSearchPlaceholder: "Que voulez-vous regarder aujourd'hui?",
      SignIn: "Se connecter",
      SignUp: "S'inscrire",
      NamePlaceholder: "Nom",
      EmailPlaceholder: "E-mail",
      PasswordPlaceholder: "Mot de passe",
      Or: "Ou",
      SignInwithGoogle: "Se connecter avec Google",
      Already_have_an_Account: "Vous avez déjà un compte?",
      New_to_Netflix: "Nouveau sur Netflix?",
      Sign_in_now: "Connectez-vous maintenant.",
      Sign_up_now: "Inscrivez-vous maintenant.",
      Now_Playing_Movies: "Films en cours",
      Popular_Movies: "Films populaires",
      Top_Rated_Movies: "Films les mieux notés",
      Upcoming_Movies: "Films à venir",
      Trending_Movies: "Films tendance",
      Log_Out: "Se déconnecter",
      Play_Now: "Jouer maintenant",
      More_Info: "Plus d'infos",
      Frequently_Asked_Questions: "Questions fréquentes",
    },
  };
  
  export default Lang